import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {PREVIEW_ACCOUNT_MENU_DOTS_ICON} from './preview-account-menu-dots.types';
import styles from './preview-account-menu-dots.module.scss';

export function PreviewAccountMenuDots(): ReactElement {
  return <Icon ariaHidden icon={PREVIEW_ACCOUNT_MENU_DOTS_ICON} size={IconSize.SIZE_ICON_16} className={styles.previewAccountMenuDots} />;
}
